import script from "./Feature.vue?vue&type=script&setup=true&lang=js"
export * from "./Feature.vue?vue&type=script&setup=true&lang=js"

import "./Feature.vue?vue&type=style&index=0&id=5c79a5ee&lang=scss"

const __exports__ = script;

export default __exports__